// STONOTE: Uncomment below if you need to support multiple stacked modals
// let modalLockCount = 0;
export const lockBodyScroll = () => {
    const doc = document.documentElement;
    const body = document.body;
    // modalLockCount = modalLockCount + 1;
    // if (modalLockCount > 1) return;
    const scrollbar = window.innerWidth - doc.clientWidth;
    if (scrollbar > 0) {
        body.style.paddingRight = `${scrollbar}px`;
    }
    body.style.overflow = 'hidden';
};
export const unlockBodyScroll = () => {
    const body = document.body;
    // modalLockCount = Math.max(modalLockCount - 1, 0);
    // if (modalLockCount > 0) return;
    body.style.overflow = '';
    body.style.paddingRight = '';
};
//# sourceMappingURL=scroll-lock.js.map